import { createSlice } from '@reduxjs/toolkit'
import type { BronzeWriteTypeCode } from 'app/constants/bronzeWriteType'

type currentSubTemplate = {
  value: string
  label: string
  isSubmitted: boolean
}

type InitialState = {
  templateConfigData: []
  templateDetails: {
    name: string
    description: string
    type: string
    piiApplicable: boolean
    allowDeletion: boolean
    storageLocation: string
    source: string
    status: string
    isSubmitted: boolean
    bronzeTableName: string
    bronzeWriteType: BronzeWriteTypeCode | ''
    bronzeWriteTypeLabel: string
  }
  fileTemplateDetails: {
    templateId: number
    name: string
    description: string
    type: string
    piiApplicable: boolean
    allowDeletion: boolean
    storageLocation: string
    source: string
    status: string
    isSubmitted: boolean
    bronzeTableName: string
    bronzeWriteType: BronzeWriteTypeCode | ''
    bronzeWriteTypeLabel: string
  }
  templateSubDetails: []
  submittedSubTemplateDetails: { noOfSubmitted: number }
  currentSubTemplateDetails: currentSubTemplate
}

const initialState: InitialState = {
  templateConfigData: [],
  templateDetails: {
    name: '',
    description: '',
    type: '',
    piiApplicable: false,
    storageLocation: '',
    source: '',
    status: 'Waiting for approval',
    isSubmitted: false,
    bronzeTableName: '',
    bronzeWriteType: '',
    bronzeWriteTypeLabel: '',
    allowDeletion: false,
  },
  fileTemplateDetails: {
    templateId: 0,
    name: '',
    description: '',
    type: '',
    piiApplicable: false,
    storageLocation: '',
    source: '',
    status: 'Waiting for approval',
    isSubmitted: false,
    bronzeTableName: '',
    bronzeWriteType: '',
    bronzeWriteTypeLabel: '',
    allowDeletion: false,
  },
  templateSubDetails: [],
  submittedSubTemplateDetails: { noOfSubmitted: 0 },
  currentSubTemplateDetails: { value: '', label: '', isSubmitted: false },
}

export const templateConfig = createSlice({
  name: 'templateConfig',
  initialState,
  reducers: {
    getTemplateDetails: (state, action) => {
      const { templateDetails } = action.payload
      state.templateDetails = templateDetails
    },
    getFileTemplateDetails: (state, action) => {
      const { fileTemplateDetails } = action.payload
      state.fileTemplateDetails = fileTemplateDetails
    },
    getTemplateRulesData: (state, action) => {
      const { templateRow } = action.payload
      state.templateConfigData = templateRow
    },
    getSubTemplateDetails: (state, action) => {
      const { templateSubDetails } = action.payload
      state.templateSubDetails = templateSubDetails
    },
    getCurrentSubTemplateDetails: (state, action) => {
      const { currentSubTemplateDetails } = action.payload
      state.currentSubTemplateDetails = currentSubTemplateDetails
    },
    getSubmittedSubTemplateDetails: (state, action) => {
      const { submittedSubTemplateDetails } = action.payload
      state.submittedSubTemplateDetails = submittedSubTemplateDetails
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getTemplateDetails,
  getFileTemplateDetails,
  getTemplateRulesData,
  getSubTemplateDetails,
  getCurrentSubTemplateDetails,
  getSubmittedSubTemplateDetails,
} = templateConfig.actions

export default templateConfig.reducer
